// extracted by mini-css-extract-plugin
export default {"link":"HomePage_link__LYAQq"};